import apiService from "./api";

export interface PendingOwnershipTransfer {
	id: string;
	/** SENT: o dono atual pediu; RECEIVED: o usuário logado é o destinatário. */
	direction: "SENT" | "RECEIVED";
	fromName: string;
	toName: string;
	templeName: string;
	expiresAt: string;
	createdAt: string;
}

const ownershipTransferService = {
	request(toUserId: string) {
		return apiService.post("/ownership-transfers", { toUserId });
	},
	async getPending(): Promise<PendingOwnershipTransfer | null> {
		// O Nest responde `null` com corpo vazio; o axios entrega "".
		return (await apiService.get("/ownership-transfers/pending")) || null;
	},
	accept(id: string) {
		return apiService.post(`/ownership-transfers/${id}/accept`);
	},
	decline(id: string) {
		return apiService.post(`/ownership-transfers/${id}/decline`);
	},
	cancel(id: string) {
		return apiService.post(`/ownership-transfers/${id}/cancel`);
	},
};

export default ownershipTransferService;
